import { render, staticRenderFns } from "./CampaignAnalytics.vue?vue&type=template&id=58142984&scoped=true&"
import script from "./CampaignAnalytics.vue?vue&type=script&lang=js&"
export * from "./CampaignAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58142984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('58142984', component.options)
    } else {
      api.reload('58142984', component.options)
    }
    module.hot.accept("./CampaignAnalytics.vue?vue&type=template&id=58142984&scoped=true&", function () {
      api.rerender('58142984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/clients/CampaignAnalytics.vue"
export default component.exports